<template lang="pug">
  #wrapper
    .rap-header
      .text 相続関係図
    .scroll_area
      canvas#canvas
    .button_area(v-if="showButton")
      button.blue_button(@click="step02") STEP2：遺産入力へ
      button(@click="back") 前の画面に戻る
</template>

<script lang="js">
import canvas from '../../module/canvas';

export default {
  props: {
    type: {
      type: Number,
      default: 1,
    },
    family: {
      type: Object,
      default: {},
    },
    redraw: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    showButton: false,
  }),

  watch: {
    redraw(a, b) {
      this.draw();
    },
    $route(to, from) {
      if (to.path.indexOf('step') === 1) {
        this.showButton = false;
      } else {
        this.showButton = true;
      }
    },
  },
  methods: {
    draw() {
      canvas.draw(this.family);
      this.$emit('update_image', canvas.base64());
    },
    step02() {
      this.$emit('go_step02', '');
    },
    back() {
      history.back();
    },
  },
  mounted() {
    canvas.init('#canvas');
    this.draw();
    if (this.$route.path.length === 1 || this.$route.path.indexOf('step') === 1) {
      this.showButton = false;
    } else {
      this.showButton = true;
    }
  },
};
</script>

<style lang="sass" scoped>
#wrapper
  width: 100%
  min-height: 100%
  background-color: $light-gray
  padding-top: 20px
  //overflow: auto
  #canvas
    width: 500px
  .rap-header
    display: none
  .title
    background-color: $white
    margin: 0 20px 20px 20px
    padding: 12px 0
    text-align: center
    color: $main-red
    font-size: 18px
  .button_area
    display: none
@media screen and (max-width: $break-header)
  #wrapper
    .scroll_area
      width: 100%
      overflow-x: scroll
      #canvas
        width: 500px
    .rap-header
      display: block
      text-align: center
      width: 100%
      background-color: $white
      margin-top: -20px
      margin-bottom: 20px
      padding-top: 50px
      padding-bottom: 50px
      .text
        border: solid 1px $clear-blue
        display: initial
        padding: 10px 40px
        font-size: 20px
    .button_area
      background-color: #fff
      padding-top: 40px
      display: flex
      flex-direction: column
      align-items: center
      button
        &:nth-child(2)
          margin-top: 20px
</style>